import { render, staticRenderFns } from "./website-info.vue?vue&type=template&id=13a00d58&scoped=true&"
import script from "./website-info.vue?vue&type=script&lang=js&"
export * from "./website-info.vue?vue&type=script&lang=js&"
import style0 from "./website-info.vue?vue&type=style&index=0&id=13a00d58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a00d58",
  null
  
)

export default component.exports